import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BodyScrollLockService {
  private static readonly LOCK_CLASS = 'body-scroll-locked';
  private count = 0;

  public lock(): void {
    this.count++;
    if (this.count === 1) {
      document.body.classList.add(BodyScrollLockService.LOCK_CLASS);
    }
  }

  public unlock(): void {
    if (this.count === 0) {
      return;
    }
    this.count--;
    if (this.count === 0) {
      document.body.classList.remove(BodyScrollLockService.LOCK_CLASS);
    }
  }
}
